import { Link } from "react-router-dom";
import { useIntl } from "react-intl";
import { Avatar } from "mastodon/components/avatar";
import { DisplayName } from "mastodon/components/display_name";
import { selectAccountStatus } from "mastodon/selectors/statuses";
import { useAppSelector } from "mastodon/store";
import { accountHandle } from "./home-context";

export const DriscollPostHeader = ({ statusId, menu, leadingMeta, trailingMeta, wrapperProps, onHeaderClick }) => {
  const status = useAppSelector((state) => selectAccountStatus(state, statusId));
  const intl = useIntl();
  if (!status) return null;
  const account = status.account;
  return (
    <header {...wrapperProps} className="dr-post-header" onClick={onHeaderClick} onAuxClick={onHeaderClick}>
      <div className="dr-post-author">
        <Link to={`/@${account.acct}`} aria-label={account.acct} data-hover-card-account={account.id} className="dr-post-author-avatar">
          <Avatar account={account} size={36} />
        </Link>
        <div className="dr-post-author-details">
          <Link to={`/@${account.acct}`} data-hover-card-account={account.id}>
            <strong>
              <DisplayName account={account} variant="simple" />
            </strong>
          </Link>
          <Link to={`/@${account.acct}`} data-hover-card-account={account.id}>
            <small>{accountHandle(account)}</small>
          </Link>
          {leadingMeta && <span className="dr-post-badges">{leadingMeta}</span>}
        </div>
      </div>
      <Link
        className="dr-post-time"
        to={`/@${account.acct}/${status.id}`}
        title={intl.formatDate(status.created_at, { dateStyle: "full", timeStyle: "short" })}
      >
        <time dateTime={status.created_at}>
          {intl.formatDate(status.created_at, { day: "numeric", month: "short" })}
        </time>
        {status.edited_at && <span title="Edited"> *</span>}
      </Link>
      {trailingMeta}
      {menu}
    </header>
  );
};
